Service = App.loadClass 'core::Angular/Service'

class exports.UserSelectionService extends Service
    constructor: (@rootScope) ->
        @options = {
            selected_year: null
            selected_field: null
        }

        @layer = null


    getOptions: () ->
        return @options


    getYear: () ->
        return @options.selected_year


    getField: () ->
        return @options.selected_field

    getLayer: () ->
        return @layer


    setOptions: (params) ->
        @options = {
            selected_year: params.year
            selected_field: params.field
        }

    setLayer: (param) ->
        @layer = param


    setYear: (year) ->
        @options.selected_year = year


    setField: (field) ->
        @options.selected_field = field
